import viLocale from 'element-ui/lib/locale/lang/vi' //引入element语言包
const vi = {
  posterPage: {
    title1:'Tính năng đăng ký sắp ra mắt!',
    title2:'Đăng ký gia hạn, nâng cấp đặc quyền!',
    title3:'Giảm giá độc quyền, phí gia hạn có lời hơn',
    title4:'Nhận mã trao đổi, bạn có thể tham khảo ý kiến người bán hàng đã mua thiết bị',
    title5:'Ưu tiên trải nghiệm chức năng',
    function1:'Chi tiết chức năng:',
    function2:'Phí gia hạn dịch vụ cơ bản (phiên dịch đồng truyền, trợ lý hội nghị, trợ lý thông minh)..',
    function3:'Thuê bao dịch vụ giá trị gia tăng (dịch ngoại tuyến, dịch cuộc gọi âm thanh và video)...',
  },
  RedemptionCodePage: {
    RedemptionCode: 'Mã đổi',
    ValueAddedServices: 'Dịch vụ giá trị gia tăng',
    UpgradedExperience: 'Quyền lợi giá trị gia tăng độc quyền, trải nghiệm nâng cấp',
    OfflineTranslation: 'Dịch ngoại tuyến',
    NoInternet: 'Không cần kết nối mạng · Dịch ngay lập tức · An toàn và bảo mật',
    GoToSubscribe: 'Đăng ký',
    AudioAndVideoCall: 'Cuộc gọi âm thanh/video',
    RealTimeCall: 'Dịch giọng nói thời gian thực · Giao tiếp không bị cản trở',
    BaseService: 'Dịch vụ cơ bản',
    AIAssistant: 'Chức năng: Đồng truyền dịch · Trợ lý hội nghị · Trợ lý AI',
    LanguagesSetting:'Thiết lập ngôn ngữ',
    languages1:'Trung Quốc giản thể',
    languages2:'Trung Quốc truyền thống',
    languages3:'Tiếng Việt',
    languages4:'Tiếng Việt',
    languages5:'Hàn Quốc',
    languages6:'Tiếng Việt',
    languages7:'Tiếng Việt',
    languages8:'Tiếng Việt',
    languages9:'Tiếng Việt',
    languages10:'Bồ Đào Nha',
    languages11:'Tiếng Ý',
    languages12:'Thổ nhĩ kỳ',
    languages13:'Tiếng Việt',
    languages14:'Tiếng Việt',
    languages15:'Tiếng Hindi',
    languages16:'Tiếng Việt',
    languages17:'Thái Lan',
    languages18:'Ba Tư',
  },
  Login: {
    ToLogin: 'Đăng nhập',
    PhoneLogin: 'Số điện thoại Đăng nhập',
    EmailLogin: 'Đăng nhập hộp thư',
    PhonePlaceholder: 'Vui lòng nhập số điện thoại',
    EmailPlaceholder: 'Enter email',
    Code: 'Mã xác nhận',
    and: 'Và',
    BeforeText: 'Tạo tài khoản thay mặt bạn đồng ý và tuân thủ',
    UserAgreement: 'Thỏa thuận người dùng',
    privacy: 'Chính sách bảo mật',
    errorMessage: 'Lỗi CAPTCHA',
    readTitle: 'Đọc và đồng ý với thỏa thuận sau',
    readBefore: 'Để giữ thông tin cá nhân của bạn an toàn, vui lòng đọc và đồng ý trước',
    cancel: 'Hủy bỏ',
    agree: 'Đồng ý và tiếp tục',
    error1:'Vui lòng nhập địa chỉ hộp thư hợp lệ',
    error2:'Vui lòng nhập đúng số điện thoại',
    error3:'Vui lòng nhập CAPTCHA',
    success:'Đăng nhập thành công'
  },
  OffLinePage: {
    title: 'Dịch ngoại tuyến',
    NoInternet: 'Không cần kết nối mạng · Dịch ngay lập tức · An toàn và bảo mật',
    ServiceLife: 'Thời hạn sử dụng',
    forever: 'Sử dụng vĩnh viễn',
    describe: 'Hướng dẫn đăng ký',
    describeItem1: '1. Chức năng dịch thuật ngoại tuyến là thanh toán một lần, sử dụng vĩnh viễn, sử dụng quyền để theo dõi thiết bị Bluetooth, nếu thay đổi thiết bị, cần đăng ký lại mã đổi dịch ngoại tuyến.',
    describeItem2: '2. Không hoàn lại phí sau khi đăng ký mã ủy quyền.',
    describeItem3: '3. Hỗ trợ 10 ngôn ngữ: Trung Quốc, Anh, Đức, Nhật Bản, Hàn Quốc, Hindi, Thái Lan, Tây Ban Nha, Pháp, Nga.',
    quantity: 'Số lượng',
    payType: 'Phương thức thanh toán',
    card: 'Thẻ ngân hàng',
    wx: 'Trang chủ',
    GooglePay: 'Google Pay',
    subscribe: 'Đăng ký',
    RMB: '¥',
    confirm:'Xác nhận',
    cardNumber:'Số thẻ',
    periodOfValidity:'Ngày hết hạn',
    safetyCode:'Mã bảo mật',
    name:'Tên',
    yearAndMonth:'Năm/tháng',
    message1:'Số lượng không thể bằng 0',
    popTip:'Gợi ý ấm áp',
    popText1:'Vui lòng đọc kỹ và hiểu',
    popText2:'Thỏa thuận trả phí dịch thuật ngoại tuyến',
    popText3:'Tôi đã đọc và đồng ý',
    popText4:'Đã đọc và đồng ý',
  },
  AudioVideoPage: {
    title: 'Cuộc gọi âm thanh/video',
    RealTime: 'Dịch giọng nói thời gian thực · Giao tiếp không bị cản trở',
    describe: 'Hướng dẫn đăng ký',
    describeItem1: '1. Chức năng phiên dịch cuộc gọi video âm thanh là nạp giá trị mua phút, số phút bắt đầu tính từ khi kết nối cuộc gọi, quyền hạn đi theo tài khoản, nếu đăng nhập vào tài khoản khác, cần nạp giá trị lại.',
    describeItem2: '2- Kết nối và buộc các thiết bị khác nhau sau khi nạp tài khoản có thể được sử dụng như thường lệ.',
    describeItem3: '3. Chức năng phiên dịch cuộc gọi video âm thanh không được hoàn phí sau khi nạp đầy.',
    payType: 'Phương thức thanh toán',
    card: 'Thẻ ngân hàng',
    wx: 'Trang chủ',
    GooglePay: 'Google Pay',
    subscribe: 'Đăng ký',
    RMB: '¥',
    sale: 'Giảm giá',
    confirm:'Xác nhận',
    time1:'giây',
    time2:'phút',
    time3:'Giờ',
    time4:'Ngày',
    time5:'Tháng',
    time6:'Năm',
  },
  OffLineResult: {
    title1: 'Dịch ngoại tuyến',
    title2: 'Cuộc gọi âm thanh/video',
    title3: 'Dịch vụ cơ bản',
    success: 'Subscribe to Thành công',
    fail: 'Đăng ký thất bại',
    stock:'Mã đổi hàng sẵn sàng',
    saveTitle: 'Lưu mã đổi, vào APP để đổi.',
    code: 'Mã đổi',
    tip1: 'Mã này chỉ được sử dụng để đổi chức năng dịch ngoại tuyến',
    tip2: 'Mã này chỉ được sử dụng để đổi chức năng dịch cuộc gọi âm thanh/video',
    tip3: 'Mã này chỉ được sử dụng để đổi tính năng gia hạn dịch vụ cơ bản',
    save: 'Lưu',
    time: 'Thời gian đăng ký:',
    copy: 'Sao chép',
    copySuccess: 'Sao chép thành công',
    loading:'Đang tải',
    paySuccess:'Thanh toán thành công'
  },
  RedemptionList: {
    title: 'Mã đổi của tôi',
    view: 'Xem thêm',
    time: 'Thời gian đăng ký:',
  },
  MyRedemption: {
    title: 'Mã đổi của tôi',
    code: 'Mã đổi',
    time: 'Thời gian đăng ký:',
    copy: 'Sao chép',
    tip1: 'Mã này chỉ được sử dụng để đổi chức năng dịch ngoại tuyến',
    tip2: 'Mã này chỉ được sử dụng để đổi chức năng dịch cuộc gọi âm thanh/video',
    tip3: 'Mã này chỉ được sử dụng để đổi tính năng gia hạn dịch vụ cơ bản',
    save: 'Lưu',
    success:"Hoạt động thành công"
  },
  basePage:{
    error1:'Không có thông tin về sản phẩm',
    message1:'Vui lòng chọn sản phẩm',
    title:'Dịch vụ cơ bản',
    function:'Chức năng: Đồng truyền dịch · Trợ lý hội nghị · Trợ lý AI',
    describe: 'Hướng dẫn đăng ký',
    describe1:'1. Sau khi gia hạn phí dịch vụ cơ bản như phiên dịch đồng truyền, trợ lý hội nghị, thời hạn có hiệu lực theo thiết bị, nếu thay đổi thiết bị, cần gia hạn lại phí.',
    describe2:'2. Không hoàn lại phí sau khi gia hạn dịch vụ cơ bản.',
    payType: 'Phương thức thanh toán',
    card: 'Thẻ ngân hàng',
    wx: 'Trang chủ',
    GooglePay: 'Google Pay',
    subscribe: 'Đăng ký',
    RMB: '¥',
    sale: 'Giảm giá',
    month:'Tháng',
    confirm:'Xác nhận',
    month1:'1 tháng',
    month2:'Nửa năm',
    month3:'1 năm'
  },
  ...viLocale //这里引入element语言包目的是在切换语言的时候，element的组件里面的文字能跟随切换
}
// 导出
export default vi;
